export interface PODisclaimerLabelConstructor {
  id: number
  description: string
  text: string
}

export class PODisclaimerLabel {
  readonly id: number
  readonly description: string
  readonly text: string

  constructor(data: PODisclaimerLabelConstructor) {
    this.id = data.id
    this.description = data.description
    this.text = data.text
  }

  // Case-insensitive uniqueness check backing the create-modal guard
  // ("Purchase order labels should be unique.")
  public hasSameDescription(description: string): boolean {
    return this.description.toLowerCase() === description.trim().toLowerCase()
  }
}
